import type { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";
import MuiSwitch from "@mui/material/Switch";

export interface SwitchProps extends MuiSwitchProps {
  className?: string;
  name: string;
  label?: string;
}

const Switch: React.FC<SwitchProps> = ({
  className,
  name,
  label = "",
  color = "primary",
  ...rest
}) => {
  return (
    <RMHSwitch
      aria-label={label}
      className={className}
      color={color}
      name={name}
      {...rest}
    />
  );
};

export default Switch;

const RMHSwitch = (props: MuiSwitchProps) => (
  <MuiSwitch
    disableRipple
    focusVisibleClassName=".Mui-focusVisible"
    {...props}
  />
);
